/* CYL Pendant Add-On — Temple Mount Soil (v3)
 *
 * Two placements, one file:
 *
 * 1. PDP checkbox card (rendered by snippets/buy-buttons.liquid).
 *    The theme's <tms-cart-drawer> already intercepts EVERY
 *    form[action$="/cart/add"] submit in document capture phase
 *    (assets/cart-drawer.js _onSubmit) — so we must NOT intercept the
 *    submit ourselves or the main item gets added twice. Instead we
 *    observe the submit, remember the pendant variant as "pending",
 *    and when the drawer announces success via its 'cart:updated'
 *    event we add the pendant and ask the drawer to refresh again
 *    ('cart:refresh').
 *
 * 2. Cart drawer upsell row (rendered by sections/cart-drawer.liquid,
 *    lives in the drawer FOOTER because the drawer client-rerenders
 *    .cd-body innerHTML on every refresh). Visibility is JS-driven
 *    from cart contents: shown when the cart holds an eligible
 *    necklace (handle list on the data attribute) and the pendant is
 *    not already in the cart.
 *
 * Plus the thumbnail lightbox for the PDP card.
 */
(function () {
  'use strict';

  var PENDANT_HANDLE = 'the-covenant-pendant';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
  }

  function requestDrawerRefresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* ── 1. PDP checkbox card ───────────────────────────────────── */

  function findForm(optin) {
    var fid = optin.getAttribute('data-cyl-addon-form');
    if (fid) {
      var byId = document.getElementById(fid);
      if (byId && byId.tagName === 'FORM') return byId;
    }
    var productForm = optin.closest('product-form');
    if (productForm) {
      var f = productForm.querySelector('form[action*="/cart/add"]');
      if (f) return f;
    }
    return null;
  }

  function attachCard(optin) {
    var checkbox = optin.querySelector('[data-cyl-addon-checkbox]');
    if (!checkbox) return;
    var form = findForm(optin);

    function render() {
      optin.classList.toggle('added', checkbox.checked);
      if (!form) return;
      if (checkbox.checked) {
        form.setAttribute('data-cyl-addon-variant', optin.getAttribute('data-cyl-addon-variant-id') || '');
      } else {
        form.removeAttribute('data-cyl-addon-variant');
      }
    }

    function toggle() {
      checkbox.checked = !checkbox.checked;
      render();
    }

    checkbox.addEventListener('change', render);

    // Pill button + card surface toggle the state (per the design
    // prototype); the zoom image keeps its own lightbox behavior.
    optin.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cyl-addon-zoom-trigger]')) return;
      if (e.target.closest && e.target.closest('[data-cyl-addon-toggle]')) { toggle(); return; }
      toggle();
    });

    optin.__cylRender = render;
    render();

    // Variant-aware zoom: data-cyl-addon-zoom-map maps the product's Color
    // option value → combo image URL (this color's necklace + the pendant
    // on one chain). Keeps the lightbox in sync with the selected variant.
    var zoomTrigger = optin.querySelector('[data-cyl-addon-zoom-trigger]');
    var zoomMap = null;
    try {
      var rawMap = optin.getAttribute('data-cyl-addon-zoom-map');
      if (rawMap) zoomMap = JSON.parse(rawMap);
    } catch (err) { zoomMap = null; }

    if (zoomMap && zoomTrigger) {
      var scopeEl = optin.closest('.shopify-section') || document;

      // The map is keyed by variant id; read the form's current selection.
      var syncZoom = function () {
        if (!form) return;
        var vid = null;
        try { vid = new FormData(form).get('id'); } catch (err) { /* noop */ }
        if (vid == null) {
          var idInput = form.querySelector('input[name="id"]:not([disabled])');
          if (idInput) vid = idInput.value;
        }
        vid = String(vid || '');
        if (vid && Object.prototype.hasOwnProperty.call(zoomMap, vid)) {
          zoomTrigger.setAttribute('data-cyl-addon-zoom', zoomMap[vid]);
          // The card thumbnail shows the same combo at thumbnail size.
          var thumb = optin.querySelector('[data-cyl-addon-thumb]');
          if (thumb) thumb.src = zoomMap[vid].replace('width=1400', 'width=240');
        }
      };

      // The picker updates the form's id input asynchronously after its own
      // section re-render, so retry on a short backoff; the zoom click
      // handler also calls __cylSyncZoom directly, which guarantees the
      // lightbox is correct at the moment it opens.
      var syncSoon = function () {
        setTimeout(syncZoom, 60);
        setTimeout(syncZoom, 400);
        setTimeout(syncZoom, 1000);
      };
      optin.__cylSyncZoom = syncZoom;
      syncZoom();
      scopeEl.addEventListener('change', syncSoon);
      var pf = optin.closest('product-form') || (form && form.closest('product-form'));
      if (pf) {
        ['variant:change', 'product:variant-change'].forEach(function (ev) {
          pf.addEventListener(ev, syncSoon);
        });
      }
    }
  }

  function uncheckAllCards() {
    document.querySelectorAll('[data-cyl-pendant-addon]').forEach(function (optin) {
      var checkbox = optin.querySelector('[data-cyl-addon-checkbox]');
      if (checkbox) checkbox.checked = false;
      if (optin.__cylRender) optin.__cylRender();
    });
  }

  /* ── 2. Combined add-to-cart (single request) ───────────────────
   * The drawer intercepts /cart/add submits with a document-capture
   * listener. We listen on WINDOW capture, which always fires before
   * document listeners in the capture phase, so when the add-on box is
   * ticked we replace what used to be TWO sequential adds + TWO drawer
   * refreshes (4 round-trips, ~2s) with ONE /cart/add.js call carrying
   * both items, then a single drawer refresh + open. When the box is
   * unticked we don't touch the event and the theme behaves stock.
   * Any failure falls back to the theme's normal single-item flow. */

  function drawerEl() { return document.querySelector('tms-cart-drawer'); }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var addonId = parseInt(form.getAttribute('data-cyl-addon-variant'), 10);
    if (!addonId) return;

    e.preventDefault();
    e.stopPropagation();

    function fallback() {
      form.removeAttribute('data-cyl-addon-variant');
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }

    var fd = new FormData(form);
    var mainId = parseInt(fd.get('id'), 10);
    if (!mainId) return fallback();

    var qty = parseInt(fd.get('quantity'), 10);
    if (!isFinite(qty) || qty < 1) qty = 1;

    var mainItem = { id: mainId, quantity: qty };
    var props = {};
    var hasProps = false;
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) { props[m[1]] = val; hasProps = true; }
    });
    if (hasProps) mainItem.properties = props;
    var sp = fd.get('selling_plan');
    if (sp) mainItem.selling_plan = parseInt(sp, 10) || sp;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    // Optimistic open, mirroring the drawer's own add flow.
    var d0 = drawerEl();
    if (d0 && typeof d0.open === 'function') d0.open();

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [mainItem, { id: addonId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('combined add failed');
        uncheckAllCards();
        var d = drawerEl();
        if (d && typeof d.refresh === 'function') {
          return d.refresh().then(function () { d.open(); });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { fallback(); })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
      });
  }, true);

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart) updateDrawerAddon(cart);
  });

  /* ── 3. Cart drawer upsell row ──────────────────────────────── */

  function getDrawerAddonEl() {
    return document.querySelector('[data-cyl-drawer-addon]');
  }

  function updateDrawerAddon(cart) {
    var el = getDrawerAddonEl();
    if (!el || !cart) return;
    var eligibleHandles = (el.getAttribute('data-cyl-addon-handles') || '').split(',');
    var addonVariantId = parseInt(el.getAttribute('data-cyl-addon-variant-id'), 10);
    var hasEligible = false;
    var hasPendant = false;
    (cart.items || []).forEach(function (it) {
      if (it.handle === PENDANT_HANDLE || it.variant_id === addonVariantId) hasPendant = true;
      if (eligibleHandles.indexOf(it.handle) !== -1) hasEligible = true;
    });
    el.hidden = !(hasEligible && !hasPendant);
  }

  function refreshDrawerAddonFromServer() {
    if (!getDrawerAddonEl()) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateDrawerAddon(cart); })
      .catch(function () { /* silent */ });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cyl-drawer-addon-add]') : null;
    if (!btn) return;
    var el = getDrawerAddonEl();
    var variantId = el ? parseInt(el.getAttribute('data-cyl-addon-variant-id'), 10) : 0;
    if (!variantId) return;
    btn.disabled = true;
    addToCart(variantId)
      .then(function (res) { if (res.ok && el) el.hidden = true; })
      .catch(function () { /* silent */ })
      .finally(function () {
        btn.disabled = false;
        requestDrawerRefresh();
      });
  });

  /* ── 4. PDP thumbnail lightbox ──────────────────────────────── */

  function closeLightbox() {
    var lb = document.querySelector('.cyl-addon-lightbox');
    if (lb) lb.parentNode.removeChild(lb);
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') closeLightbox();
  }

  function escapeHtmlText(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function openLightbox(src, caption) {
    closeLightbox();
    var captionText = caption || 'The Covenant Pendant — pendant only, slides onto your chain';
    var lb = document.createElement('div');
    lb.className = 'cyl-addon-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'The Covenant Pendant, enlarged view');
    lb.innerHTML =
      '<button type="button" class="cyl-addon-lightbox-close" aria-label="Close">&times;</button>' +
      '<div><img src="' + src + '" alt="The Covenant Pendant — Silver Star of David with Cross">' +
      '<div class="cyl-addon-lightbox-caption">' + escapeHtmlText(captionText) + '</div></div>';
    lb.addEventListener('click', closeLightbox);
    document.body.appendChild(lb);
    document.addEventListener('keydown', onKey);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-cyl-addon-zoom-trigger]') : null;
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var card = trigger.closest('[data-cyl-pendant-addon]');
    if (card && card.__cylSyncZoom) card.__cylSyncZoom();
    openLightbox(trigger.getAttribute('data-cyl-addon-zoom'), trigger.getAttribute('data-cyl-addon-zoom-caption'));
  }, true);

  /* ── boot ───────────────────────────────────────────────────── */

  function bootAll(root) {
    (root || document).querySelectorAll('[data-cyl-pendant-addon]').forEach(function (optin) {
      if (optin.__cylBound) return;
      optin.__cylBound = true;
      attachCard(optin);
    });
  }

  ready(function () {
    bootAll(document);
    refreshDrawerAddonFromServer();
    document.addEventListener('shopify:section:load', function (e) {
      bootAll(e.target);
      refreshDrawerAddonFromServer();
    });
  });
})();
